import React, { useState, useEffect } from "react";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import httpService from "../../../services/httpServices/httpServices";
import helperNumber from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";
import helperTime from "../../../helpers/time";
import StatePageConstant from "./StatePageConstant";
import TypePageConstant from "./TypePageConstant";

export default function AllPageSitePublisher() {
  const params = useParams();
  const publisherID = parseInt(params.publisherID);
  const [allPageSitePublisher, setAllPageSitePublisher] = useState([]);
  const [urlSitePublisher, setUrlSitePublisher] = useState();

  useEffect(() => {
    getAllPageSitePublisher();
  }, []);

  useEffect(() => {
    if (!allPageSitePublisher) {
      return;
    }
    getSitePublisher();
  }, [allPageSitePublisher]);

  const getSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let sitePublisher = await sendRequestGetSitePublisher(publisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!sitePublisher) {
      return;
    }
    setUrlSitePublisher(sitePublisher.url.replace("https://", ""));
  };

  const sendRequestGetSitePublisher = async (publisherID) => {
    const headersRequest = getHeaderRequest();
    let pages;
    try {
      pages = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/publisher/site/" + publisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return pages.data.data;
  };

  const getHeaderRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getAllPageSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    let allPageSitePublisher = await sendRequestGetAllPageSitePublisher(
      publisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!allPageSitePublisher) {
      return;
    }
    setAllPageSitePublisher(allPageSitePublisher.reverse());
  };

  const sendRequestGetAllPageSitePublisher = async (publisherID) => {
    const headersRequest = getHeaderRequest();
    let pages;
    try {
      pages = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/publisher/" +
          publisherID +
          "/page",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return pages.data.data;
  };

  const generateTagHtmlAllPageSitePublisher = () => {
    return (
      <>
        <div className="d-flex flex-column-reverse flex-sm-row justify-content-sm-between">
          <div className="pt-2 pt-sm-0">
            <Link
              to={`/page/add/publisher/${publisherID}`}
              className="btn btn-success"
            >
              <span className="pl-2">
                <i className="fa fa-plus"> </i>
              </span>
              <span>اضافه صفحه کردن به سایت نمایش دهنده</span>
            </Link>
          </div>
          <div className="text-left">
            <Link className="btn btn-primary" to="/publisher/all">
              <span>بازگشت</span>
              <span className="pr-2">
                <i className="fas fa-arrow-left"></i>
              </span>
            </Link>
          </div>
        </div>

        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>عنوان </td>
                <td>الگوی آدرس</td>
                <td>لینک</td>
                <td>وضعیت</td>
                <td>حالت</td>
                <td>تاریخ درج</td>
                <td>عملیات</td>
              </tr>
            </thead>
            <tbody>
              {allPageSitePublisher.map((page, index) => {
                let doseShowPositions;
                let classBadgeStatePage;
                switch (page.state) {
                  case StatePageConstant.statusSiteUserPublisher.PENDING:
                    doseShowPositions = false;
                    classBadgeStatePage = "badge-warning";
                    break;
                  case StatePageConstant.statusSiteUserPublisher.CONFIRM:
                    doseShowPositions = true;
                    classBadgeStatePage = "badge-info";
                    break;
                  case StatePageConstant.statusSiteUserPublisher.REJECT:
                    doseShowPositions = false;
                    classBadgeStatePage = "badge-danger";
                    break;
                  case StatePageConstant.statusSiteUserPublisher.REJECT_EDIT:
                    doseShowPositions = true;
                    classBadgeStatePage = "badge-danger";
                    break;
                  case StatePageConstant.statusSiteUserPublisher.PENDING_EDIT:
                    doseShowPositions = true;
                    classBadgeStatePage = "badge-warning";
                    break;
                }
                return (
                  <tr>
                    <td>{helperNumber.toPersianNum(index + 1)}</td>
                    <td>{helperNumber.toPersianNum(page.id)}</td>
                    <td>
                      {page.title}
                      {page.pattern_url.includes("/@s") ? (
                        <span className="pr-2">
                          <span className="badge badge-success">
                            {
                              TypePageConstant.typePageString()[
                                TypePageConstant.typePage.MULTI_PAGE
                              ]
                            }
                          </span>
                        </span>
                      ) : (
                        <span className="pr-2">
                          <span className="badge badge-warning">
                            {
                              TypePageConstant.typePageString()[
                                TypePageConstant.typePage.STATIC
                              ]
                            }
                          </span>
                        </span>
                      )}
                    </td>
                    <td>
                      <div dir="ltr" className="text-left">
                        {page.pattern_url}
                      </div>
                    </td>
                    <td>
                      <a
                        href={page.link}
                        target="_blank"
                        className="btn btn-info"
                      >
                        <i className="fa fa-link"></i>
                      </a>
                    </td>
                    <td>
                      <span className={`badge ${classBadgeStatePage}`}>
                        {page.state}
                      </span>
                    </td>
                    <td>
                      <div dir="ltr" className="text-center">
                        {page.active ? (
                          <span className="badge badge-success">فعال</span>
                        ) : (
                          <span className="badge badge-danger">غیر فعال</span>
                        )}
                      </div>
                    </td>
                    <td>
                      {helperNumber.toPersianNum(
                        page.created_at.split(" ")[1] +
                          " " +
                          helperTime.convertGregorianToJalali(
                            page.created_at.split(" ")[0]
                          )
                      )}
                    </td>
                    <td>
                      {doseShowPositions && (
                        <span className="pl-2">
                          <Link
                            to={`/positions/all/page/${page.id}`}
                            className="btn btn-info"
                          >
                            نمایش جایگاه ها تبلیغاتی
                          </Link>
                        </span>
                      )}
                      <span className="pl-2">
                        <Link
                          to={`/page/view/${page.id}`}
                          className="btn btn-info"
                        >
                          <i className="fa fa-info"></i>
                        </Link>
                      </span>
                      <span>
                        <Link
                          to={`/page/edit/${page.id}`}
                          className="btn btn-success"
                        >
                          <i className="fa fa-edit"></i>
                        </Link>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const generateTagHtmlDoNotHaveAnyPages = () => {
    return (
      <>
        <div className="text-left">
          <Link className="btn btn-primary" to="/publisher/all">
            <span>بازگشت</span>
            <span className="pr-2">
              <i className="fas fa-arrow-left"></i>
            </span>
          </Link>
        </div>
        <div className="d-flex flex-column flex-md-row">
          <div className="text-center text-md-right">
            <img src="/assets/img/do-not-have-pages.svg" />
          </div>
          <div className="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
            <p>
              {" "}
              شما در حال حاضر هیچ صفحه ای برای این سایت نمایش دهنده ندارید :(
            </p>
            <p> برای شروع کار یک صفحه برای این نمایش دهنده بسازید.</p>
            <p>
              <Link
                to={`/page/add/publisher/${publisherID}`}
                className="btn btn-success"
              >
                <span className="pl-2">
                  <i className="fa fa-plus"> </i>
                </span>
                <span>اضافه صفحه کردن به سایت نمایش دهنده</span>
              </Link>
            </p>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title={`صفحات سایت ${urlSitePublisher}`} />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {allPageSitePublisher.length === 0
                ? generateTagHtmlDoNotHaveAnyPages()
                : generateTagHtmlAllPageSitePublisher()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
